/**
 * 実績トレンド反映ダイアログの「補正前後の日合計 (kWh)」算出。
 *
 * forecast (補正前) / corrected (補正後) の各コマ値は 1 コマ (30分) あたりの
 * kWh (= 需要量) なので、日合計 kWh は 48 コマの単純総和になる (コマ→日の係数は
 * 掛けない)。 根拠: backend の CorrectSlot が「補正後想定値 = V_plan × avgRatio」
 * (丸めない、AC-DFC-EDIT-003) で kWh を返し、 plan 値も DemandKwhToMW(kWh/30min) の入力で
 * あること (= 1 コマ値の単位は kWh/コマ)。
 */

/**
 * 補正前 (plan) と補正後 (corrected) の 48 コマ値から日合計 kWh を算出する。
 *
 * @param beforeSlots 補正前の 48 コマ値 (kWh/コマ、 空コマ undefined は 0 扱い)
 * @param afterSlotValues 補正後の 48 コマ値の文字列表現 (proto Decimal の value、
 *   未設定 undefined は 0 扱い、 数値化できない文字列も 0 扱い)
 */
export function computeTrendTotals(
  beforeSlots: Array<number | undefined>,
  afterSlotValues: Array<string | undefined>,
): { beforeTotalKwh: number; afterTotalKwh: number } {
  const beforeTotalKwh = beforeSlots.reduce<number>(
    (acc, v) => acc + (v ?? 0),
    0,
  )
  const afterTotalKwh = afterSlotValues.reduce<number>((acc, v) => {
    if (v === undefined) return acc
    const n = parseFloat(v)
    return acc + (Number.isNaN(n) ? 0 : n)
  }, 0)
  return { beforeTotalKwh, afterTotalKwh }
}
